export const monitorstore = {
  namespaced: true,
  state: {
    online: 0
  },
  mutations: {
    setOnline(state: any, payload: number) {
      state.online = payload;
    }
  },
  actions: {},
  getters: {
    getOnline: function(state: any): number {
      return state.online;
    }
  }
};

// type Areas
// this._store.getters["areastore/getDataSet"]
// _store.commit("areastore/addDataSet", areaInfo)